import { useState } from "react";
import { Typography } from "antd";
import { IPaymentPageDetail } from "@app-models";

interface IProps {
  pageDetail?: IPaymentPageDetail | null;
}

interface MerchantLogoProps {
  logoUrl?: string;
  merchantName: string;
}

const MerchantLogo = ({ logoUrl, merchantName }: MerchantLogoProps) => {
  const [imageLoadError, setImageLoadError] = useState(false);

  if (logoUrl && !imageLoadError) {
    const src = /^https?:\/\//i.test(logoUrl) ? logoUrl : `data:image/png;base64,${logoUrl}`;
    return (
      <img
        className="left-panel-merchant-img"
        src={src}
        alt={merchantName}
        onError={() => setImageLoadError(true)}
      />
    );
  }

  return (
    <div className="left-panel-merchant-fallback">
      <span>{merchantName.charAt(0).toUpperCase()}</span>
    </div>
  );
};

const MerchantLeftPanel = ({ pageDetail }: IProps) => {
  const panelStyle = pageDetail?.imageUrl
    ? {
        backgroundImage: `linear-gradient(180deg, rgba(0,0,0,0.45) 0%, rgba(0,0,0,0.35) 50%, rgba(0,0,0,0.3) 100%), url(data:image/png;base64,${pageDetail.imageUrl})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }
    : {};

  return (
    <div className="merchant-panel" style={panelStyle}>
      <div className="merchant-panel-header">
        <div className="merchant-avatar-wrap">
          <MerchantLogo
            logoUrl={pageDetail?.merchant?.merchantLogoUrl}
            merchantName={pageDetail?.merchant?.name ?? ""}
          />
        </div>
        <Typography.Text className="merchant-name-label">
          {pageDetail?.merchant?.name}
        </Typography.Text>
      </div>
      <div className="merchant-panel-info-card">
        <Typography.Title level={4} className="panel-page-title">
          {pageDetail?.name}
        </Typography.Title>
        <Typography.Text className="panel-page-desc">
          {pageDetail?.description}
        </Typography.Text>
      </div>
    </div>
  );
};

export default MerchantLeftPanel;
